import api from '../utils/api';

export const getRetrievals = async () => {
  const { data } = await api.get('cognitive/assistants/');
  return data;
};

export const getRetrievalsInfo = async () => {
  const { data } = await api.get("cognitive/assistants/info/");
  return data;
};

export const getRetrieval = async (id) => {
  const { data } = await api.get(`cognitive/assistants/${id}/`);
  return data;
};

const RetrievalsApi = {
  getRetrievals,
  getRetrievalsInfo,
  getRetrieval,
};

export default RetrievalsApi;
